import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { TiersPage } from "@src/appV2/redesign/Tiers/Page";

export function TiersContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <TiersPage />
    </ThemeProvider>
  );
}
